import {
    ASSET_NAME_BOND,
    ASSET_NAME_CURRENCY,
    ASSET_NAME_FOND,
    ASSET_NAME_INDEX,
    ASSET_NAME_STOCK,
} from '@alfa-bank/site-invest-emitents-common/constants';

import type { TBaseUrlToAssetConfig } from './models';

export const defaultBaseUrlToAssetConfig: TBaseUrlToAssetConfig = {
    [ASSET_NAME_CURRENCY]: '/make-money/investments/catalog/currencies/t/[isin]',
    [ASSET_NAME_FOND]: '/make-money/investments/catalog/fondy/t/[isin]',
    [ASSET_NAME_INDEX]: '/make-money/investments/catalog/indeks/t/[isin]',
    [ASSET_NAME_STOCK]: '/make-money/investments/catalog/akcii/t/[isin]',
    [ASSET_NAME_BOND]: '/make-money/investments/catalog/obligacii/t/[isin]',
};
